import React from 'react'
import { SelectItemProps } from './types'
import styles from './SelectItem.module.scss'

export const SelectItem = ({ label }: SelectItemProps) => {
  return <div className={styles['select-item']}>{label}</div>
}
